import { render, staticRenderFns } from "./GO.vue?vue&type=template&id=0a824e86&scoped=true"
import script from "./GO.vue?vue&type=script&setup=true&lang=js"
export * from "./GO.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a824e86",
  null
  
)

export default component.exports